import { magnoliaServiceAPI, magnoliaServicePLAPI } from '@/store/api-instance'
import { IFetchArticlesRequest } from '@/store/modules/articles/interfaces/articles/api/fetchArticles/IFetchArticlesRequest'
import { IFetchArticlesResponse } from '@/store/modules/articles/interfaces/articles/api/fetchArticles/IFetchArticlesResponse'
import { IFetchSelectedArticleRequest } from '@/store/modules/articles/interfaces/selectedArticle/api/fetchSelectedArticle/IFetchSelectedArticleRequest'

import { IArticle, ITags } from '@/store/modules/articles/interfaces/IArticle'

import { AxiosResponse } from 'axios'

export const articlesAPI = {
  async fetchArticles (dto: IFetchArticlesRequest): Promise<IFetchArticlesResponse> {
    const articlesApi = 'articles/GetArticlesNewListPL'

    let params: any = dto

    if (dto?.Tags?.length !== undefined) {
      params = new URLSearchParams()
      dto.Tags.forEach(t => {
        params.append('Tags', t)
      })

      delete dto.Tags

      for (const [key, value] of Object.entries(dto)) {
        params.append(key, value)
      }

      console.error(params)

      const response: AxiosResponse = await magnoliaServicePLAPI.get<IFetchArticlesResponse>(articlesApi + '?' + params.toString())
      return response.data
    }

    const response: AxiosResponse = await magnoliaServicePLAPI.get<IFetchArticlesResponse>(articlesApi, { params: dto })
    return response.data
  },
  async fetchArticlesPublic (dto: IFetchArticlesRequest): Promise<IFetchArticlesResponse> {
    const articlesApi = 'publicarticles/GetPublicArticlesNewListPL'

    let params: any = dto

    if (dto?.Tags?.length !== undefined) {
      params = new URLSearchParams()
      dto.Tags.forEach(t => {
        params.append('Tags', t)
      })

      delete dto.Tags

      for (const [key, value] of Object.entries(dto)) {
        params.append(key, value)
      }

      console.error(params)

      const response: AxiosResponse = await magnoliaServiceAPI.get<IFetchArticlesResponse>(articlesApi + '?' + params.toString())
      return response.data
    }

    const response: AxiosResponse = await magnoliaServiceAPI.get<IFetchArticlesResponse>(articlesApi, { params })
    return response.data
  },
  async fetchSelectedArticle (dto: IFetchSelectedArticleRequest): Promise<IArticle> {
    const { isLoggedIn } = dto
    const selectedArticlesApi = isLoggedIn ? 'articles' : 'publicarticles'
    const response: AxiosResponse = await magnoliaServiceAPI.get<IArticle>(`${selectedArticlesApi}${dto.path}`)
    return response.data
  },
  async fetchArticlesTag (): Promise<ITags> {
    const response: AxiosResponse = await magnoliaServiceAPI.get('articles/GetArticlesNewListTagsPL')
    return response.data
  },
  async fetchArticlesPublicTag (): Promise<ITags> {
    const response: AxiosResponse = await magnoliaServiceAPI.get('publicarticles/GetPublicArticlesNewListTags')
    return response.data
  }
}
